import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  getDepartmentPolicy,
  getOrganizationPolicy,
  getRoleBasedPolicy,
  getUserPolicy,
} from '../../../../redux/features/hrPolicySlice';
import { Box, Tab, Tabs, Typography, Fab, Zoom } from '@mui/material';
import { useSelector } from 'react-redux';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import PolicyViewer from './PolicyViewer';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const HrPolicy = () => {
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [showScroll, setShowScroll] = useState(false);

  const { loading, organizationPolicy, departmentPolicy, roleBasedPolicy, userPolicy } = useSelector(
    (state) => state.hrPolicy
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const profile = JSON.parse(localStorage.getItem('cred')).profile;

  useEffect(() => {
    if (value === 0) {
      dispatch(getOrganizationPolicy());
    } else if (value === 1) {
      dispatch(getDepartmentPolicy(profile.departmentId));
    } else if (value === 2) {
      dispatch(getRoleBasedPolicy(profile.roleID));
    } else {
      dispatch(getUserPolicy(profile.userId));
    }
  }, [value]);

  // ✅ Track scroll to show/hide button
  useEffect(() => {
    const handleScroll = () => {
      setShowScroll(window.scrollY > 200);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Box sx={{ width: '100%' }}>
      {/* Tabs Header */}
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="primary"
          indicatorColor="primary"
          aria-label="policy tabs"
          variant="fullWidth"
          sx={{ minHeight: 36 }}
        >
          <Tab label="Organization" sx={{ fontSize: '0.75rem', minHeight: 36, minWidth: 60, py: 0 }} />
          <Tab label="Department" sx={{ fontSize: '0.75rem', minHeight: 36, minWidth: 60, py: 0 }} />
          <Tab label="Role Based" sx={{ fontSize: '0.75rem', minHeight: 36, minWidth: 60, py: 0 }} />
          <Tab label="User" sx={{ fontSize: '0.75rem', minHeight: 36, minWidth: 60, py: 0 }} />
        </Tabs>
      </Box>

      {/* Tabs Content */}
      <TabPanel value={value} index={0}>
        <PolicyViewer data={organizationPolicy} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <PolicyViewer data={departmentPolicy} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <PolicyViewer data={roleBasedPolicy} />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <PolicyViewer data={userPolicy} />
      </TabPanel>

      {/* ✅ Scroll to Top Button */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Zoom in={showScroll}>
          <Fab color="primary" size="small" onClick={scrollToTop} sx={{ position: 'fixed', bottom: 0 }}>
            <KeyboardArrowUpIcon />
          </Fab>
        </Zoom>
      </Box>
    </Box>
  );
};

export default HrPolicy;
